// 複数行テキストを初期表示分に切り詰める。全行数も返し、「もっと見る」ボタン要否の判定に使う
export const truncateText = (
  text: string,
  limit: number
): { text: string; totalLines: number; isTruncated: boolean } => {
  const lines = text.split('\n')
  if (lines.length <= limit) {
    return { text, totalLines: lines.length, isTruncated: false }
  }
  return {
    text: lines.slice(0, limit).join('\n'),
    totalLines: lines.length,
    isTruncated: true,
  }
}
